module.exports = __webpack_public_path__ + "img/rightBottom3.3b17617.svg";